// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_footerWrapper_ymXBx {
  position: relative;
  height: 418px;
  width: 100%;
}

.footer_footerPiece_z1epu {
  position: absolute;
  height: 418px;
  width: auto;
}

.footer_dynamicSlot_fl0SN {
  position: absolute;
  top: 33px;
  overflow: hidden;
}

.footer_svgContainer_Fybk9 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.footer_svgContainer_Fybk9 svg {
  height: auto;
  width: 100%;
}

.footer_qrCode_s6bOd {
  position: absolute;
}

.footer_dottedLine_lUJIN {
  position: relative;
  height: auto;
  top: -6px;
  left: 0;
}

.footer_hslLogo_dyJWv {
  top: 69px;
  left: 23px;
  height: 385px;
}

.footer_hslLogo_dyJWv svg {
  height: 100%;
  width: auto;
  fill: red;
}

.footer_customerService_Usdft {
  top: 40px;
  right: 11px;
  height: auto;
  width: 458px;
}

.footer_url_sl7J6 {
  position: absolute;
  font-size: 20px;
  font-family: GothamXNarrow-Medium;
  color: black;
  padding: 2px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/stopPoster/footer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,OAAO;AACT;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".footerWrapper {\n  position: relative;\n  height: 418px;\n  width: 100%;\n}\n\n.footerPiece {\n  position: absolute;\n  height: 418px;\n  width: auto;\n}\n\n.dynamicSlot {\n  position: absolute;\n  top: 33px;\n  overflow: hidden;\n}\n\n.svgContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.svgContainer svg {\n  height: auto;\n  width: 100%;\n}\n\n.qrCode {\n  position: absolute;\n}\n\n.dottedLine {\n  position: relative;\n  height: auto;\n  top: -6px;\n  left: 0;\n}\n\n.hslLogo {\n  top: 69px;\n  left: 23px;\n  height: 385px;\n}\n\n.hslLogo svg {\n  height: 100%;\n  width: auto;\n  fill: red;\n}\n\n.customerService {\n  top: 40px;\n  right: 11px;\n  height: auto;\n  width: 458px;\n}\n\n.url {\n  position: absolute;\n  font-size: 20px;\n  font-family: GothamXNarrow-Medium;\n  color: black;\n  padding: 2px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerWrapper": `footer_footerWrapper_ymXBx`,
	"footerPiece": `footer_footerPiece_z1epu`,
	"dynamicSlot": `footer_dynamicSlot_fl0SN`,
	"svgContainer": `footer_svgContainer_Fybk9`,
	"qrCode": `footer_qrCode_s6bOd`,
	"dottedLine": `footer_dottedLine_lUJIN`,
	"hslLogo": `footer_hslLogo_dyJWv`,
	"customerService": `footer_customerService_Usdft`,
	"url": `footer_url_sl7J6`
};
module.exports = ___CSS_LOADER_EXPORT___;
